import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md px-2 py-0.5 text-sm font-medium sm:text-[0.8125rem]",
  {
    variants: {
      variant: {
        default: "bg-primary-soft text-primary-strong",
        secondary: "bg-neutral-100 text-neutral-700",
        outline: "text-neutral-700 ring-1 ring-neutral-950/10",
        warning: "bg-amber-100 text-amber-900",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

export const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
);
